module.exports = __webpack_public_path__ + "img/4.c7c0341f.png";